import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { WebhookComponent } from './components/webhook/webhook.component';

const webhookRoutes: Routes = [

    { path: 'webhook', data: { breadcrumbs: 'Webhook' },
        canActivate: [AuthGuard],
        children: [
            { path: '', component: WebhookComponent, canActivate: [AuthGuard] },
        ]
    }

];

@NgModule({
    imports: [RouterModule.forChild(webhookRoutes)],
    exports: [RouterModule]
})

export class WebhookRoutingModule {}
